export const directionDictionary = {
    1: 'Front photo',
    2: 'Back photo',
    3: 'Nadir photo',
}

export const photoAttributeDictionary = {
    altitude: {
        header: 'Altitude',
        visible: true,
        renderType: 'numeric',
        unit: 'm',
    },
    createdByUserId: {
        header: 'Created by (id)',
        visible: false,
        renderType: 'text',
    },
    createdByUserName: {
        header: 'Created by (name)',
        visible: true,
        renderType: 'text',
    },
    createdDateTime: {
        header: 'Created on',
        visible: true,
        renderType: 'datetime',
    },
    modifiedByUserName: {
        header: 'Modified by (name)',
        visible: false,
        renderType: 'text',
    },
    modifiedDateTime: {
        header: 'Modified on',
        visible: false,
        renderType: 'datetime',
    },
    dateTime: {
        header: 'Date',
        visible: true,
        renderType: 'datetime',
    },
    direction: {
        header: 'Photo direction',
        visible: true,
        renderType: 'select',
        dictionary: directionDictionary,
    },
    fileName: {
        header: 'File name',
        visible: false,
        renderType: 'text',
    },
    fileStatus: {
        header: 'File status',
        visible: false,
        renderType: 'text',
    },
    id: {
        header: 'Id',
        visible: false,
        renderType: 'text',
    },
    projectId: {
        header: 'Project Id',
        visible: false,
        renderType: 'text',
    },
    workspaceId: {
        header: 'Project Id',
        visible: false,
        renderType: 'text',
    },
    latitude: {
        header: 'Latitude',
        visible: true,
        renderType: 'numeric',
        unit: '\u00B0',
    },
    longitude: {
        header: 'Longtitude',
        visible: true,
        renderType: 'numeric',
        unit: '\u00B0',
    },
    maxZoom: {
        header: 'Maximal zoom',
        visible: false,
        renderType: 'text',
    },
    moduleColor: {
        header: 'Color',
        visible: false,
        renderType: 'text',
    },
    height: {
        header: 'Height',
        visible: false,
        renderType: 'numeric',
        unit: 'px',
    },
    width: {
        header: 'Width',
        visible: false,
        renderType: 'numeric',
        unit: 'px',
    },
    roll: {
        header: 'Roll',
        visible: false,
        renderType: 'numeric',
        unit: 'deg',
    },
    pitch: {
        header: 'Pitch',
        visible: false,
        renderType: 'numeric',
        unit: 'deg',
    },
    yaw: {
        header: 'Yaw',
        visible: false,
        renderType: 'numeric',
        unit: 'deg',
    },
    faultsCount: {
        header: 'Faults count',
        visible: false,
        renderType: 'text',
    },
}


// WEBPACK FOOTER //
// ./src/utilities/photoDictionary.js